import React, { FC } from 'react';
import { DefaultPageLayoutProps } from './DefaultPageLayoutProps';
import Stack from '@mui/material/Stack';
import { Divider } from '@mui/material';

const DefaultPageLayout: FC<DefaultPageLayoutProps> = ({
  sidebar,
  mainPart,
}) => {
  return (
    <Stack
      sx={{
        minHeight: 'calc(100vh - 73px)',
        width: '100%',
      }}
    >
      <Stack direction="row" spacing={3}>
        {sidebar()}

        <Divider orientation="vertical" flexItem />

        <Stack
          sx={{
            pt: 3,
            backgroundColor: '#ffffff',
            width: '100%',
            minHeight: 'calc(100vh - 76px)',
            display: 'flex',
            flexFlow: 'column',
            overflow: !sidebar ? 'auto' : 'hidden',
          }}
        >
          {mainPart()}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default DefaultPageLayout;
